/**
 * Production API Implementation of IDashboardRepository
 */
import { dashboardApi } from '../api/dashboardApi';
import { DashboardData, ExecutiveDashboardData } from '../types/dashboard.types';
import { IDashboardRepository } from './IDashboardRepository';

export class ApiDashboardRepository implements IDashboardRepository {
  async getExecutiveDashboard(societyId: number | null, signal?: AbortSignal): Promise<ExecutiveDashboardData> {
    return dashboardApi.getExecutiveDashboard(societyId, signal);
  }

  async getDashboardData(societyId?: number | null, signal?: AbortSignal): Promise<DashboardData> {
    return dashboardApi.getDashboardData(societyId, signal);
  }
}
